// @flow

import React from 'react';
import { MapSearchContext } from '../MapSearchContainer';

const ResultsListContainer = () => {
  return (
    <MapSearchContext.Consumer>
      {({ translations, markers }) => {
        return (
          <div className="locations-wrapper container">
            <h2>
              {translations
                ? translations['search_results_label']
                : 'Search results'}
            </h2>
            {!markers || markers.length == 0 ? (
              <p>{translations['no_results_label']}</p>
            ) : (
              <div className="results">
                {markers.map((marker, index) => {
                  const {
                    title,
                    city,
                    country,
                    '@id': url,
                    description,
                  } = marker;
                  return (
                    <div className="location-res" key={index}>
                      <div className="location-cont">
                        <h6>
                          <a href={url}>{title}</a>
                        </h6>
                        {country || city ? (
                          <div className="location">
                            <i className="fas fa-map-marker-alt" />{' '}
                            {country && country.length ? country : ''}
                            {country && country.length && city && city.length
                              ? ','
                              : ''}{' '}
                            {city && city.length ? city : ''}
                          </div>
                        ) : (
                          ''
                        )}
                        {description.length ? (
                          <p className="description">{description}</p>
                        ) : (
                          ''
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        );
      }}
    </MapSearchContext.Consumer>
  );
};

export default ResultsListContainer;
